import { Dialog, Transition } from "@headlessui/react"
import React, { Fragment } from "react"
import {mPrint} from "../../util/mPrint";

export enum ModalPosition {
    top,
    center,
    bottom,
}

interface IProps {
    isOpen: boolean,
    children: any,
    containerClassName?: string,
    position?: ModalPosition,
    onClose?: () => void
}

export default function CustomModal(props: IProps) {
    const {isOpen, children, containerClassName = "", position = ModalPosition.center, onClose} = props

    let alignBaseline = "align-middle"
    let containerMargin = ""
    if (position === ModalPosition.top) {
        alignBaseline = "align-top"
        containerMargin = "mt-20"
    } else if (position === ModalPosition.bottom) {
        alignBaseline = "align-bottom"
        containerMargin = "mb-20"
    }

    return (
        <Fragment>
            <Transition appear show={isOpen} as={Fragment}>
                <Dialog
                    as="div"
                    className="fixed inset-0 z-10 overflow-y-auto bg-black bg-opacity-20"
                    onClose={() => {
                        onClose && onClose()
                        mPrint("on close Dialog")
                    }}
                >
                    <div className="min-h-screen px-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <Dialog.Overlay className="fixed inset-0" />
                        </Transition.Child>

                        {/* This element is to trick the browser into centering the modal contents. */}
                        <span className={`inline-block h-screen ${alignBaseline}`} aria-hidden="true">&#8203;</span>

                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <div className={`inline-block max-w-full p-4 overflow-hidden text-left align-middle transition-all transform bg-white shadow-2xl rounded-lg ${containerMargin} ${containerClassName}`}>
                                {children}
                            </div>
                        </Transition.Child>
                    </div>
                </Dialog>
            </Transition>
        </Fragment>
    )
}
